export const convertDate = date => {
  return Date.UTC(
    ...date
      .replace(/(Date.UTC\(|\))/g, '')
      .split(',')
      .map(item => parseInt(item, 10)),
  );
}